import React, { useEffect, useState } from "react";
import { IoMdArrowBack } from "react-icons/io";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import config from "../config";
import { getApi } from "./AppApis";

const PrivacyPolicyScreen = () => {
    const [privacySections, setPrivacySections] = useState([]);
    const [expandedSections, setExpandedSections] = useState({});

    useEffect(() => {
        document.title = `Privacy Policy | ${config.get("COMPANY_NAME")}`;

        const fetchPrivacyPolicy = async () => {
            try {
                const response = await fetch("https://admin.onmls.com/api/privacy_policy/get_privacy_policy");
                const data = await response.json();
                if (data && data.data) {
                    setPrivacySections(data.data);
                    // Initialize all sections as collapsed except first one
                    const initialExpandedState = {};
                    data.privacy.forEach((section, index) => {
                        initialExpandedState[section.id] = index === 0; // First section expanded by default
                    });
                    setExpandedSections(initialExpandedState);
                }
            } catch (error) {
                console.error("Error fetching privacy policy:", error);
            }
        };

        fetchPrivacyPolicy();
    }, []);

    const toggleSection = (sectionId) => {
        setExpandedSections((prevState) => ({
            ...prevState,
            [sectionId]: !prevState[sectionId],
        }));
    };

    const handleEmailPress = () => {
        window.location.href = "mailto:sell@airebrokers.com";
    };

    const handlePhonePress = () => {
        window.location.href = "tel:727-855-8555";
    };

    const handleAddressPress = async () => {
        const address = encodeURIComponent("2801 Hennepin Ave #258, Minneapolis, MN 55408");
        await window.open(`https://www.google.com/maps/search/?api=1&query=${address}`, "_blank");
    };

    const renderSectionContent = (section) => {
        if (section.id === "67e5663a9c7e041911414e35") {
            // Contact Us section
            return (
                <div className="tw-text-gray-600">
                    {section.description.split("\n").map((line, index) => {
                        if (line.includes("AiRE Brokers")) {
                            return <p key={index}>{line.replace("AiRE Brokers", config.get("COMPANY_NAME"))}</p>;
                        } else if (line.includes("2801 Hennepin Ave")) {
                            return (
                                <button key={index} onClick={() => handleAddressPress()} className="tw-text-blue-600 tw-underline tw-block tw-my-1">
                                    {line}
                                </button>
                            );
                        } else if (line.includes("Phone:")) {
                            return (
                                <button key={index} onClick={() => handlePhonePress()} className="tw-text-blue-600 tw-underline tw-block tw-my-1">
                                    {line}
                                </button>
                            );
                        } else if (line.includes("Email:")) {
                            return (
                                <button key={index} onClick={handleEmailPress} className="tw-text-blue-600 tw-underline tw-block tw-my-1">
                                    {line}
                                </button>
                            );
                        }
                        return <p key={index}>{line}</p>;
                    })}
                </div>
            );
        }

        // For other sections, split by newlines and bullet points
        const lines = section.description.split("\n");
        return (
            <div className="tw-text-gray-600">
                {lines.map((line, index) => {
                    if (line.startsWith("-") || line.startsWith("•")) {
                        return (
                            <ul key={index} className="tw-list-disc tw-pl-6">
                                <li className="tw-text-gray-600">{line.replace(/^[-•]\s*/, "")}</li>
                            </ul>
                        );
                    }
                    return <p key={index}>{line}</p>;
                })}
            </div>
        );
    };

    return (
        <div className="tw-p-6 tw-bg-gray-100">
            <button onClick={() => window.history.back()} className="mb-4">
                <IoMdArrowBack size={30} />
            </button>

            <div className="tw-border-b tw-border-gray-300 tw-mb-6 tw-pb-4">
                <h1 className="tw-text-3xl tw-font-bold tw-text-gray-800">Privacy Policy for {config.get("COMPANY_NAME")}</h1>
                <p className="tw-text-gray-600 tw-text-sm tw-mt-2">Last updated: 10/8/2024</p>
            </div>

            {privacySections.map((section) => (
                <div key={section.id} className="tw-mb-6">
                    <button
                        onClick={() => toggleSection(section.id)}
                        className="tw-flex tw-justify-between tw-items-center tw-w-full tw-border-b tw-border-gray-200 tw-py-2 tw-w-full"
                    >
                        <h2 className="tw-text-xl tw-font-semibold tw-text-gray-700 tw-text-left">{section.header}</h2>
                        {expandedSections[section.id] ? <FaAngleUp /> : <FaAngleDown />}
                    </button>

                    {expandedSections[section.id] && <div className="tw-mt-2">{renderSectionContent(section)}</div>}
                </div>
            ))}
        </div>
    );
};

export default PrivacyPolicyScreen;
